import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers'
import moment from 'moment'

export const EventService = {
    addEvent,
    loadEvents,
    modifyEvent,
    deleteEvent,
    graphEvents
}

function addEvent({
    category,
    type,
    description,
    date
}, locationID) {
    const query = `mutation{
        addEvents(
            locationID: ${JSON.stringify(locationID)},
            category: ${JSON.stringify(category)},
            type: ${type ? JSON.stringify(type) : null},
            description: ${description ? JSON.stringify(description) : null},
            date: ${JSON.stringify(new Date(date))}
        ) {
            id
        }
    }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.addEvents);
    });
}

function loadEvents(locationID, index, nbElem) {
    const query = `{
        eventsByLocation(
            locationID: ${JSON.stringify(locationID)},
            index: ${index}
            number: ${nbElem}
            ) {
            events {
                id
                category
                type
                description
                date
            }
            nbPages
        }
    }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.eventsByLocation);
    });
}

function modifyEvent({
    id,
    category,
    type,
    description,
    date
}) {
    const wellFormattedDate = new Date(date)
    const query = `mutation{
        modifyEvents(
            id: ${JSON.stringify(id)},
            category: ${JSON.stringify(category)},
            type: ${type ? JSON.stringify(type) : null},
            description: ${description ? JSON.stringify(description) : null},
            date: ${JSON.stringify(wellFormattedDate)},
        ) {
            id
        }
    }`
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.modifyEvents)
    })
}

function deleteEvent(id) {
    const query = `mutation{
        deleteEvents(
            id: ${JSON.stringify(id)}
        ) {
            id
        }
    }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    }
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.deleteEvents);
    });
}

function graphEvents(locationIDs, dateFrom, date, aggregation) {
    let startDateStartOfDay = moment(dateFrom).startOf('day').toDate()
    let endDateEndOfDay = moment(date).endOf('day').toDate()
  const query = `{
    eventsForChart(
      dateFrom: ${JSON.stringify(startDateStartOfDay)},
      date: ${JSON.stringify(endDateEndOfDay)},
      locationIDs: ${JSON.stringify(locationIDs)},
      aggregation: ${JSON.stringify(aggregation)}) {
      event {
        id
        category
        type
        description
        date
      }
      index
    }
  }`;
  const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/graphql', ...authHeader() },
      body: query
  }
  return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
      return handleHttpResponse(response)
      .then(data => data.eventsForChart);
  });
}